export default __webpack_public_path__ + "static/media/12t.4cb18218.jpg";